<template>
    <div id="online-service" >
        <!-- <iframe class="service-iframe" src="https://tb.53kf.com/code/wx/d32248f01a9b4a55876fecc313d08ab94/1"></iframe> -->
        <a href='javascript:;' class="customer" onclick='easemobim.bind({configId: "cd639fa3-423b-4bb8-8c8b-f0404bba7e14"})' v-if="isLogin">
            <img src="@/assets/customer.png" alt="">
            <span>快联系我</span>
        </a>
        <div style="height:100%;" v-else>页面错误</div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            isLogin: sessionStorage.getItem('isLogin')
        }
    },
    methods: {

    },
    mounted(){
        if(this.isLogin){
            if(document.body.previousElementSibling.tagName.toLowerCase() == 'script' && document.body.previousElementSibling.src == 'http://kefu.easemob.com/webim/easemob.js?configId=cd639fa3-423b-4bb8-8c8b-f0404bba7e14'){
                return;
            }else {
                var scr = document.createElement("script");
                scr.src = '//kefu.easemob.com/webim/easemob.js?configId=cd639fa3-423b-4bb8-8c8b-f0404bba7e14';
                document.documentElement.insertBefore(scr, document.body);
                window.easemobim = window.easemobim || {};
                easemobim.config = {
                    hide: true,
                    autoConnect: true    
                };
                // setTimeout(() => {
                //     this.$nextTick(() => {
                //         document.getElementsByClassName('easemobim-mobile')[0].style.setProperty("width","100%","important");
                //         document.getElementsByClassName('easemobim-mobile')[0].style.setProperty("height","100%","important");
                //         document.getElementById('em-widgetPopBar').style.right = 10;
                //         document.getElementById('em-widgetPopBar').style.bottom = 10;
                //         console.log(document.getElementsByClassName('easemobim-mobile')[0].style.width)
                //     })
                // }, 1000);
            }
        }
    }
}
</script>
<style lang="less" scoped>
    #online-service{
        width: 100%;
        height: 100%;

    //     .service-iframe{
    //         width: 100%;
    //         height: 100%;
    //     }
    

        .customer {
            position: fixed;
            background: #fff;
            right: 20px;
            bottom: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 4px;
            border: 1px solid #1296db;
            border-radius: 20px;
            img {
                width: 25px;
            }
            span{
                color: #1296db;
                font-size: 16px;
            }
        }
    }
</style>
